import store from 'store'

export default function getServerUrl() {
  const { baseURL } = store.getters['setting/getSetting']
  if (baseURL) return decodeURIComponent(baseURL)

  return process.env.API_URL
}

export const getIdentityServerUrl = () => process.env.IDENTITY_URL
